import React, { useState, useContext } from "react";
import ActionsContext from "common/ActionsContext";
import Modal from "common/Modal.jsx";

const PolicyRateProfileSettingsHelpModal = () => {
  const [open, setOpen] = useState(false);
  const actions = useContext(ActionsContext);
  actions.recv("open-settings-help", function () {
    setOpen(true);
  });
  const doClose = () => setOpen(false);
  if (open !== true) {
    return null;
  }

  return (
    <Modal
      title="Policy-Rate Profile settings"
      onClose={doClose}
      content={() => (
        <React.Fragment>
          <p>
            These profiles match the name of the Subscriber Rate Policy assigned
            to the subscriber session.
          </p>
          <ul>
            <li>
              <b>NAME</b>: Profile name.
            </li>
            <li>
              <b>POLICY-RATE</b>: Pattern of the Subscriber Rate Policy name.
              Wildchar * is supported. Example: "golden-rates-*".
            </li>
            <li>
              <b>PRIORITY</b>: Evaluation priority. Lower numbers evaluated
              first. (Number from -9999 to 9999).
            </li>
          </ul>
        </React.Fragment>
      )}
    />
  );
};

export default PolicyRateProfileSettingsHelpModal;
